import { net_common } from "@/api/http";
export const API_STDSDC01C01 = (...params) =>
  net_common.post("/api/STDSDC01C01", ...params)
